import { IProductTemplateTableEditor } from "components/ComponentTypeTypes";
import { InputNumberValueChangeEvent } from "primereact/inputnumber";
import { InputSwitchChangeEvent } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { MultiSelectChangeEvent } from "primereact/multiselect";
import React from "react";
import { T } from "services/lang/LanguageService";


interface ProductTemplateFilterConfigProps {
    currentConfig: IProductTemplateTableEditor;
    handleConfigChange: (
        e:
            | React.ChangeEvent<HTMLInputElement>
            | InputNumberValueChangeEvent
            | InputSwitchChangeEvent
            | MultiSelectChangeEvent
    ) => void;
}


const ProductTemplateFilterConfig = ({ currentConfig, handleConfigChange }: ProductTemplateFilterConfigProps) => {
    return (
        <div className="grid p-fluid gap-3">
            <div className="w-full md:w-3 gap-2 flex flex-column justify-content-center">
                <label htmlFor="filter">{T("word.hidden-filter")}</label>
                <InputText
                    id="filter"
                    value={currentConfig?.filter ?? ""}
                    onChange={handleConfigChange}
                />
            </div>
            <div className="w-full md:w-3 gap-2 flex flex-column justify-content-center">
                <label htmlFor="defaultFilter">{T("word.default-filter")}</label>
                <InputText
                    id="defaultFilter"
                    value={currentConfig?.defaultFilter ?? ""}
                    onChange={handleConfigChange}
                />
            </div>
            <div className="w-full md:w-3 gap-2 flex flex-column justify-content-center">
                <label htmlFor="optionalFilter">{T("word.optional-filter")}</label>
                <InputText
                    id="optionalFilter"
                    value={currentConfig?.optionalFilter ?? ""}
                    onChange={handleConfigChange}
                />
            </div>
            <div className="w-full md:w-3 gap-2 flex flex-column justify-content-center">
                <label htmlFor="optionalFilterBtnLabel">{T("word.optional-filter-btn-label")}</label>
                <InputText
                    id="optionalFilterBtnLabel"
                    value={currentConfig?.optionalFilterBtnLabel ?? ""}
                    onChange={handleConfigChange}
                />
            </div>
        </div>
    );
};

export default ProductTemplateFilterConfig;